import React from 'react'
import { DEMO_AUTH_ENABLED } from '@/lib/env'
import { useAuth, useAuthStore } from '@/stores/authStore'
import type {
  AuthContextType,
  OrgTier,
  Organization,
  Permission,
  Session,
  User,
  UserRole,
} from '@/contexts/auth/types'
import { DemoAuthProvider } from './auth/providers/DemoAuthProvider'
import { ClerkAuthProvider } from './auth/providers/ClerkAuthProvider'

export type { AuthContextType, OrgTier, Organization, Permission, Session, User, UserRole }
export { useAuth, useAuthStore }

export function SignedIn({ children }: { children: React.ReactNode }) {
  const isLoaded = useAuthStore((s) => s.isLoaded)
  const isSignedIn = useAuthStore((s) => s.isSignedIn)
  if (!isLoaded) return null
  return isSignedIn ? <>{children}</> : null
}

export function SignedOut({ children }: { children: React.ReactNode }) {
  const isLoaded = useAuthStore((s) => s.isLoaded)
  const isSignedIn = useAuthStore((s) => s.isSignedIn)
  if (!isLoaded) return null
  return !isSignedIn ? <>{children}</> : null
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  if (DEMO_AUTH_ENABLED) {
    return <DemoAuthProvider>{children}</DemoAuthProvider>
  }
  return <ClerkAuthProvider>{children}</ClerkAuthProvider>
}
